import React from "react";

import TrashImage from "../../../assets/result/result-b.png";

import ResultPageLayout from "../ResultPageLayout";

const ResultPage3 = () => {
  return (
    <ResultPageLayout
      img={TrashImage}
      title="노력이 필요한 시민!"
      hashText="3일이면_집이_아수라장"
    >
      쓰레기통이 없는 세상이라면..
      <br />
      3일 안에 집이 아수라장이 되겠군요ㅠㅠ <br />
      하지만 걱정하지 말아요! <br />
      쓰레기를 줄이는 방법은 <b>무궁무진 하답니다.</b>
      <br />
      <br />
      우리가 할 수 있는 노력 (적어도) 세 가지
      <br />
      <br />
      텀블러 들고 다니기
      <br />
      장 볼 때 장바구니 챙기기
      <br />
      배달용기 씻어서 분리배출 하기
      <br />
      .<br />
      .<br />
      .<br />
      <br />
      이 외에도 다양한 방법들이 있답니다. <br />
      <br />
      우선, <br />
      <b>
        내가 버린 쓰레기들이 어디서 오고 <br />
        어디로 가는지 함께 알아볼까요? <br />
        그리고 환경을 위해 <br />
        쓰레기를 줄일 수 있는 <br />
        다양한 방법들도 알아보아요!
      </b>
      <br />
      <br />
      그 외에도 쓰레기를 줄일 수 있는 방법, <br />
      혹은 정책 제안이 있다면 <b>의견을 남겨주세요!</b>
    </ResultPageLayout>
  );
};

export default ResultPage3;
